<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <span>{{$store.state.user.full_name}}</span>
      <img
        src="img/avatars/7.jpg"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
    </template>
    <template slot="dropdown">
      <div>
        <h6 class="text-capitalize text-center">your dropdown</h6>
        <ol>
          <li>one</li>
          <li>two</li>
          <li>three</li>
        </ol>
      </div>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";

export default {
  name: "DefaultHeaderDropdown",
  data() {
    return {
      user: {}
    };
  },
  components: {
    AppHeaderDropdown
  },
  mounted() {    
    const { $store } = this;

    if ($store.state.user) this.user = $store.state.user;
    console.log(this.user);
  }
};
</script>

